import React from 'react';

// Styles & Assets
import styles from './TablePollAssignButton.module.css';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import AssignPollDialog from '../AssignPollDialog/AssignPollDialog';

// Interfaces
import { Poll } from '../../../interfaces/Poll';

// Language
import { useTranslation } from 'react-i18next';

const TablePollAssignButton: React.FC<{
    poll: Poll,
    assign: boolean,
    disabled?: boolean
}> = ({ poll, assign, disabled = false }) => {

    const { t } = useTranslation();

    const [showAssignDialog, setShowAssignDialog] = useState<boolean>(false);

    const handleAssignClick = (evt: React.MouseEvent<HTMLElement>) => {
        evt.stopPropagation();
        if (disabled) return;
        setShowAssignDialog(true);
    };

    return (
        <div className={styles.buttonWrapper}>
            <button
                onClick={handleAssignClick}
                className={styles.assignButton}
                disabled={disabled}
            >
                {assign ? t('assign') : t('unassign')}
            </button>

            {!disabled && (
                <Modal show={showAssignDialog} setShowModal={setShowAssignDialog}>
                    <AssignPollDialog
                        assign={assign}
                        poll={poll}
                        showModal={setShowAssignDialog}
                    />
                </Modal>
            )}
        </div>
    );
};

export default TablePollAssignButton;